// extracted by mini-css-extract-plugin
export default {"reset_password":"ResetPassword_reset_password__2yJgF"};